import { getAuthentication } from "../../lib/auth";
import { BETTING_WEBSITE_RELATIVES_URL } from "../../lib/env";
import { gqlRequest } from "../../lib/functions";
import { BETTINGWEBSITEPAYMENTGATEWAYGQLSCHEMA } from "../../lib/gql/BettingWebsite.PaymentGateway";
import { IBettingWebsitePaymentGatway } from "../../types/BettingWebsite.PaymentGateway";

export async function getPaymentMethods(): Promise<
  IBettingWebsitePaymentGatway[]
> {
  const gqlString = `query{
        GetBettingWebsitePaymentGateways{
            ${BETTINGWEBSITEPAYMENTGATEWAYGQLSCHEMA}
        }
    }`;
  try {
    const response = await gqlRequest<{
      GetBettingWebsitePaymentGateways: IBettingWebsitePaymentGatway[];
    }>({
      query: gqlString,
      endpoint: BETTING_WEBSITE_RELATIVES_URL,
      headers: {
        authorization: `Bearer ${getAuthentication()}`,
      },
    });
    if (response.errors && response.errors.length > 0) {
      throw new Error(response.errors[0].message);
    }
    return response?.data?.GetBettingWebsitePaymentGateways || [];
  } catch (err) {
    throw err;
  }
}
